import { createContext, useContext, useState } from "react";
import { normalizeResumeTheme } from "../utils/resumeTheme";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState("default");
  const setTheme = (value) => {
    setThemeState(normalizeResumeTheme(value));
  };
  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useResumeTheme = () => useContext(ThemeContext);
